module.exports = __webpack_public_path__ + "assets/pacing.6d1dcc25.svg";